__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/3565d6f/_next/";